export default (el: HTMLElement, css: string) => {
  if (!css) return;
  const style = document.createElement('style');
  el.shadowRoot.append(style);
  style.appendChild(document.createTextNode(css));
};
